import ProductShadowBase from "../productShadowBase";
import ChildEntry from "./Entry";

export default class ChildEntryElement extends ProductShadowBase {
  connectedCallback() {
    this.loadAndRender(() => (
      <ChildEntry
        backendHost={this.backendHost ?? undefined}
        appPathPrefix={this.appPathPrefix ?? undefined}
        skipCart={this.skipCart}
        channel={this.channel ?? undefined}
        language={this.language ?? undefined}
      />
    ));
  }
}
